const general = [
    {
        "code": "TAF-QM110049",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/10/12~2021/10/14",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1.疫情期間，將視疫情狀況調整人數。\n" +
            "2.本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-QM110050",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/10/19~2021/10/21",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-QM110051",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/10/20~2021/10/22",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-QM110052",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/10/26~2021/10/28",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-QM110053",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/11/02~2021/11/04",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-QM110057",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/11/08~2021/11/10",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-QM110054",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/11/16~2021/11/18",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-TH110013",
        "category": "TH",
        "name": "測試實驗室主管訓練",
        "classDate": "2021/10/18~2021/10/19",
        "studentQualification": "適用於測試實驗室工作之人員。參加者應先取得本會辦理之「實驗室認證標準ISO /IEC 17025訓練」合格證書。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "線上",
        "cost": "新台幣5500",
        "description": "本課程共分兩天實施，第一天介紹制度性之要求，如TAF認證流程、如何建立符合TAF認證準備計畫，及實驗室評鑑實務經驗等。" +
            "第二天介紹技術性之要求，包括如何推動實驗室內部稽核與管理審查、能力試驗、不確定度及報告管理等，以使實驗室主管瞭解認證相關要求及準備計畫。\n" + "\n" +
            "全程參加且經測驗合格者，可獲頒本會測試實驗室主管訓練合格證書。\n" + "\n" +
            "(註)本會並無登錄及授權其他訓練機構核發TAF訓練證書。",
        "outline": "第一天：\n" + "\n" +
            "\t認證服務\n" + "\n" +
            "\t能力試驗\n" + "\n" +
            "第二天：\n" + "\n" +
            "\t計量追溯\n" + "\n" +
            "\t量測不確定度\n" + "\n" +
            "\t實驗室管理實務\n" + "\n" +
            "\t筆試測驗(選擇題及簡答題方式混合方式進行)",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
    {
        "code": "TAF-TH110011",
        "category": "TH",
        "name": "測試實驗室主管訓練",
        "classDate": "2021/11/09~2021/11/10",
        "studentQualification": "適用於測試實驗室工作之人員。參加者應先取得本會辦理之「實驗室認證標準ISO /IEC 17025訓練」合格證書。",
        "firstCourse": "",
        "enrollment": "25",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "線上",
        "cost": "新台幣5500",
        "description": "本課程共分兩天實施，第一天介紹制度性之要求，如TAF認證流程、如何建立符合TAF認證準備計畫，及實驗室評鑑實務經驗等。" +
            "第二天介紹技術性之要求，包括如何推動實驗室內部稽核與管理審查、能力試驗、不確定度及報告管理等，以使實驗室主管瞭解認證相關要求及準備計畫。\n" + "\n" +
            "全程參加且經測驗合格者，可獲頒本會測試實驗室主管訓練合格證書。\n" + "\n" +
            "(註)本會並無登錄及授權其他訓練機構核發TAF訓練證書。",
        "outline": "第一天：\n" + "\n" +
            "\t認證服務\n" + "\n" +
            "\t能力試驗\n" + "\n" +
            "第二天：\n" + "\n" +
            "\t計量追溯\n" + "\n" +
            "\t量測不確定度\n" + "\n" +
            "\t實驗室管理實務\n" + "\n" +
            "\t筆試測驗(選擇題及簡答題方式混合方式進行)",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
    {
        "code": "TAF-TH110012",
        "category": "TH",
        "name": "測試實驗室主管訓練",
        "classDate": "2021/12/14~2021/12/15",
        "studentQualification": "適用於測試實驗室工作之人員。參加者應先取得本會辦理之「實驗室認證標準ISO /IEC 17025訓練」合格證書。",
        "firstCourse": "",
        "enrollment": "30",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "高雄",
        "cost": "新台幣5500",
        "description": "本課程共分兩天實施，第一天介紹制度性之要求，如TAF認證流程、如何建立符合TAF認證準備計畫，及實驗室評鑑實務經驗等。" +
            "第二天介紹技術性之要求，包括如何推動實驗室內部稽核與管理審查、能力試驗、不確定度及報告管理等，以使實驗室主管瞭解認證相關要求及準備計畫。\n" + "\n" +
            "全程參加且經測驗合格者，可獲頒本會測試實驗室主管訓練合格證書。\n" + "\n" +
            "(註)本會並無登錄及授權其他訓練機構核發TAF訓練證書。",
        "outline": "第一天：\n" + "\n" +
            "\t認證服務\n" + "\n" +
            "\t能力試驗\n" + "\n" +
            "第二天：\n" + "\n" +
            "\t計量追溯\n" + "\n" +
            "\t量測不確定度\n" + "\n" +
            "\t實驗室管理實務\n" + "\n" +
            "\t筆試測驗(選擇題及簡答題方式混合方式進行)",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
    {
        "code": "TAF-QM110059",
        "category": "QM",
        "name": "實驗室認證規範ISO/IEC 17025訓練",
        "classDate": "2021/12/06~2021/12/08",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "30",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "新竹",
        "cost": "新台幣7700",
        "description": "ISO/IEC 17025 General requirements for the competence of calibration and testing laboratories 第四版已於2017年11月底公告為國際標準ISO/IEC 17025:2017，有鑑於本標準自1999年發布第一版並於2005年修訂為第二版，ISO/IEC 17025已廣泛地為國內外實驗室作為實驗室管理，以及國內外認證機構作為評鑑之標準。" +
            "本會透過參與國際會議及相關訓練，收集ISO/IEC 17025:2017國際標準修訂的思維，導入國內實驗室運作實例及評鑑經驗，更新訓練教材。" +
            "本課程將邀請具有實驗室運作及評鑑經驗的專家，以系統性的架構及邏輯，為您完整介紹TAF對新版ISO/IEC 17025：2017之要求，以及解析應用要點，協助實驗室人員推動實驗室管理。" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17025:2017訓練合格證書。\n" + "\n" +
            "(註) 本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "第一天：課程說明、簡介、用語及定義(CH3)、 一般要求事項(CH4)、架構要求事項(CH5)、資源要求事項(CH6)、附錄 A\n" +
            "第二天：過程要求事項 (CH7) 第7.1節至第7.8節\n" +
            "第三天：過程要求事項 (CH7) 第7.9節至第7.11節、管理系統要求事項 (CH8) 及附錄B、課程總結、筆試測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$7,200(含稅)。"
    },
    {
        "code": "TAF-LG110012",
        "category": "LG",
        "name": "實驗室內部稽核研討會",
        "classDate": "2021/10/26~2021/10/27",
        "studentQualification": "適用於實驗室品質人員、及擔任稽核工作之同仁與有興趣者。參加者應先取得本會辦理之「實驗室認證標準ISO /IEC 17025訓練」合格證書。",
        "firstCourse": "",
        "enrollment": "22",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "台中",
        "cost": "新台幣5500",
        "description": "本課程共分兩天實施，課程內容包括稽核指導綱要之架構、稽核內容重點、稽核原則、稽核計畫管理、稽核活動及稽核員能力與評估，並導入實務案例演練，以使實驗室品質人員建立內部稽核計畫，執行內部稽核，並成為優質稽核人員。" +
            "本課程參考ISO/IEC 17025內部稽核之重點及國際間對稽核引用之標準－ISO 19011。\n" +
            "本課程建議有實際參與至少3~6個月實驗室運作經驗之人員參加。\n" +
            "全程參與將由本會頒發參加證書。",
        "outline": "請於課前預習ISO/IEC 17025條文 \n" + "\n" +
            "•內部稽核的目的及成效  \n" +
            "•參考文件、用語及定義  \n" +
            "•TAF認證要求  \n" +
            "•內部稽核指導綱要  \n" +
            "壹、稽核原則  \n" + "\n" +
            "貳、管理稽核方案  \n" + "\n" +
            "參、執行稽核  \n" + "\n" +
            "–建立稽核計畫與設計查檢表 (演練一、二)  \n" +
            "–執行稽核計畫 (演練三)  \n" +
            "–稽核報告、矯正及跟催 \n" +
            "＊參考資料：稽核員之適任性與評估 ",
        "remark": "1.每班招收24人(配合中央疫情指揮中心，視疫情狀況調整人數)，開放報名至額滿為止。\n" +
            "2.本會將於開課前一週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參加者應先取得本會辦理之「實驗室認證標準ISO /IEC 17025訓練」合格證書。\n" +
            "5.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。"
    },
    {
        "code": "TAF-MU110008",
        "category": "MU",
        "name": "量測不確定度研討會(基礎班)",
        "classDate": "2021/12/20~2021/12/22",
        "studentQualification": "適用於擔任實驗室技術主管、技術人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "30",
        "enrollmentStatus": "full",
        "enrollmentType": "waiting",
        "location": "台中",
        "cost": "新台幣5500",
        "description": "國際標準ISO/IEC 17025要求定量之量測結果應有隨附量測不確定之表示才算完整。" +
            "為配合國際實驗室發展之趨勢，培訓相關量測不確定度評估人才，從量測不確定度之源起、基本觀念建立、探討到與誤差概念之差異、各種量測不確定度專有名詞之定義及隱含概念，最後聯結到統計分析手法，再透過簡單之案例說明量測不確定度評估之步驟與方法，深入淺出地引導學員進入量測不確定度評估之領域。使得學員能瞭解TAF對量測不確定之要求。\n" + "\n" +
            "全程參與將由本會頒發參加證書。",
        "outline": "※ 基本觀念與定義" +
            "※ ISO GUM 介紹" +
            "※ 量測不確定度相關之統計方法" +
            "※ 量測不確定度之評估原理" +
            "※ 量測不確定度之評估步驟" +
            "※ 量測不確定度之評估範例",
        "remark": "★實體課程，請注意下列事項\n" +
            "1. 疫情期間，將視疫情狀況調整人數。\n" +
            "2. 本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3. 若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4. 參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" + "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
    {
        "code": "TAF-PT110002",
        "category": "PT",
        "name": "能力試驗執行機構認證規範ISO/IEC 17043訓練",
        "classDate": "2021/12/07~2021/12/08",
        "studentQualification": "適用於校正/測試實驗室工作之主管、技術人員、品管人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "24",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "台北",
        "cost": "新台幣5500",
        "description": "ISO依據ISO/IEC Guide 43 及ILAC G13:08/2007之內容，於2010年2月公佈能力試驗之新標準ISO/IEC 17043:2010「Conformity assessment — General requirements for proficiency testing」，目前已為國內外認證機構採用作為能力試驗執行機構管理及認證之標準。" +
            "為求對此認證規範之了解，及可因應其技術專業建立能力試驗計畫，本課程將邀請具有執行能力試驗經驗及評鑑經驗的專家，以規範講解及實務案例之邏輯，為您完整介紹TAF對ISO/IEC 17043：2010之要求及應用。\n\n" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17043訓練合格證書。\n\n" +
            "(註)本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "ISO/IEC 17043發展歷程與名詞定義\n" +
            "技術要求與案例演練\n" +
            "管理要求與案例演練\n" +
            "綜合討論\n" +
            "筆試測驗",
        "remark": "1.每班招收35人，開放報名至額滿為止。\n" +
            "2.本會將於開課前一週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請於上課前5天通知TAF訓練業務同仁。"
    },
]

export default general;